import './DataTableColumnsListItem.css';
export var columnName = '_13ypmcy5-3-15-1';
export var columnNameContainer = '_13ypmcy4-3-15-1';
export var columnNameIndented = '_13ypmcy6-3-15-1';
export var columnNameSubdued = '_13ypmcy7-3-15-1';
export var columnsListItem = '_13ypmcy0-3-15-1';
export var dragging = '_13ypmcy3-3-15-1';
export var lastInSection = '_13ypmcy1-3-15-1';
export var noDragHandle = '_13ypmcy2-3-15-1';